import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from '@common/global';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@env/environment';
@Pipe({
  name: 'common'
})
export class CommonPipe implements PipeTransform {
  constructor(private _global: GlobalService) { }
  transform(value: any, ...args: unknown[]): any {
    if (args[0] == 'getVal') {
      return this._global.getVal(value, args[1], '');
    }else if (args[0] == 'scoreTextName') {
      return this._global.scoreTextName(value);
    }else if (args[0] == 'removeSpace') {
      return (value)?value.replace(/ /g, ''):''
    }
  }

}
